import Resource from "../base/resource";

class Scene extends Resource {
    constructor(props) {
        super(props);
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        onLoadCallback(1);
    }

    getDefaultState() {
        return {
            position: [0, 1.6, 0],
            quaternion: [0, 0, 0, 1],
            scale: [1, 1, 1],
            lasReferenceOffset: [-Infinity, -Infinity, -Infinity],
        }
    }

    setState(state, {appendState}) {
        const defaultState = this.getDefaultState();

        if (appendState) {
            defaultState.position = wv.rootObject.position.toArray();
            defaultState.quaternion = wv.rootObject.quaternion.toArray();
            defaultState.scale = wv.rootObject.scale.toArray();
        }

        const position = state.position ? new THREE.Vector3(...state.position) : new THREE.Vector3(...defaultState.position);
        const quaternion = state.quaternion ? new THREE.Quaternion(...state.quaternion) : new THREE.Quaternion(...defaultState.quaternion);
        const scale = state.scale ? new THREE.Vector3(...state.scale) : new THREE.Vector3(...defaultState.scale);
        const lasReferenceOffset = state.lasReferenceOffset ? state.lasReferenceOffset : defaultState.lasReferenceOffset;
        const isAllMinusInfinity = lasReferenceOffset.every(item => item === -Infinity);
        if (!isAllMinusInfinity) {
            point_cloud_helper.reAdjustLasModels(new THREE.Vector3(...lasReferenceOffset));
        }

        let new_mat = new THREE.Matrix4();
        new_mat.compose(position, quaternion, scale);

        if (appendState) {
            new_mat.premultiply(wv.rootObject.matrix);
        }

        rotateModelNew(new_mat.elements, false);
    }

    compareStates(startStates, endStates) {
        let startState = startStates[0];
        let endState = endStates[0];
        let startMatrix = new THREE.Matrix4().compose(
            new THREE.Vector3(...(startState.position || [0, 0, 0])),
            new THREE.Quaternion(...(startState.quaternion || [0, 0, 0, 1])),
            new THREE.Vector3(...(startState.scale || [1, 1, 1]))
        );
        let endMatrix = new THREE.Matrix4().compose(
            new THREE.Vector3(...(endState.position || [0, 0, 0])),
            new THREE.Quaternion(...(endState.quaternion || [0, 0, 0, 1])),
            new THREE.Vector3(...(endState.scale || [1, 1, 1]))
        );
        startMatrix.invert().multiply(endMatrix);
        let position = new THREE.Vector3();
        let quaternion = new THREE.Quaternion();
        let scale = new THREE.Vector3();
        startMatrix.decompose(position, quaternion, scale);
        position = position.toArray([]);
        quaternion = quaternion.toArray([]);
        scale = scale.toArray([]);
        return [{...endState, position, quaternion, scale}];
    }
}

export default Scene;
